/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable default-case */
/* eslint-disable object-shorthand */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, Typography, Button, Paper, Tooltip, Card, CardContent, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SendIcon from '@mui/icons-material/Send';
import Popover from '@mui/material/Popover';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import "react-circular-progressbar/dist/styles.css";
import { useDispatch, useSelector } from 'react-redux';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import GridViewIcon from '@mui/icons-material/GridView';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import posthog from 'posthog-js';
import Page from '../../../components/Page';
import adminServices from '../../../services/adminServices';
import LottieLoading from '../../../components/LottieLoading';
import Snackbar from '../../../components/snackbar/snackbar';
import TestComplete from '../../../assets/Images/TestComplete.png'
import { FromGeneralAssessmentView } from '../../../store/reducer'
import './index.css';
import QuestionRenderer from "./Questionrender";
import QuestionPalette from "./Questionpalet"
import Calculator from '../../../components/Calculator';
import IconCalculator from '../../../assets/Images/calculator.png';
import ProctoringWarningModal from './ProctoringWarningModal';
import useProctoring from './useProctoring';

const AssessmentSimulation = ({ fromIndex, details, onCallBack, resumeData, resumeLength, CallBackAssessmentView }) => {
  const location = useLocation()
  const { t } = useTranslation('translation');
  const [checked, setChecked] = useState(false);
  // const assessmentId = location?.state?.id
  const assessmentId = location?.state?.id || location.pathname.split('/').pop() || null;
  const isMobileDevice = () => { return /Android|iPhone|iPad|iPod|Mobi/i.test(navigator.userAgent) || window.innerWidth < 768; };
  const dispatch = useDispatch()
  const calcDraggedRef = useRef(false);
  const calcDragStartPos = useRef({ x: 0, y: 0 });
  const calcVelocity = useRef({ x: 0, y: 0 });
  const calcLastPos = useRef({ x: 0, y: 0 });
  const calcLastTime = useRef(0);
  const calcInertiaRef = useRef(null);
  const calcIsDragging = useRef(false);
  const calcPos = useRef({ x: window.innerWidth - 76, y: window.innerHeight - 132 });
  const containerRef = useRef(null);
  const tabRefs = useRef({});
  const testViewRef = useRef(false);
  const currentIndexRef = useRef(0);
  const currentSubjectRef = useRef(null);
  const startTimeRef = useRef('');
  const questionsRef = useRef([]);
  const intentionalExitRef = useRef(false);
  const allassessmentdetails = useSelector((state) => state);
  const { userInfo } = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(false);
  const [allDetails, setAllDetails] = useState('');
  const [questions, setQuestions] = useState([]);
  const [assessmentDetails, setAssessmentDetails] = useState(null);
  const [sections, setSections] = useState([]);
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const handleCalculatorOpen = () => setCalculatorOpen(true);
  const handleCalculatorClose = () => setCalculatorOpen(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const [isTimeout, setIsTimeout] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [openQuestionList, setOpenQuestionList] = useState(false);
  const [questionTimes, setQuestionTimes] = useState([]);
  const [startTime, setStartTime] = useState('');
  const [questionType, setQuestionType] = useState(null);
  const [time, setTime] = useState(0);
  const [parsedOptions, setParsedOptions] = useState([]);
  const [submodule, setSubmodule] = useState(1);
  const [testView, setTestView] = useState(false);
  const [resumeTime, setResumeTime] = useState(false);
  const [timeLeft, setTimeLeft] = useState(600);
  const [correctAnswer, setCorrectAnswer] = useState([]);
  const [isopenSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [showModuleComplete, setShowModuleComplete] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [markedForReview, setMarkedForReview] = useState({});
  const [visitedMap, setVisitedMap] = useState({});
  const [breakTimeLeft, setBreakTimeLeft] = useState(600);
  const [overlayZIndex, setOverlayZIndex] = useState('none');
  const [questionListAnchorEl, setQuestionListAnchorEl] = useState(null);
  const [showCongratulationsModal, setShowCongratulationsModal] = useState(false);
  const [showCongratulations, setShowCongratulations] = useState(false);
  const [assessmentData, setAssessmentData] = useState({});

  // ── Single source of truth for the "live" ref mirror of assessmentData ──
  // Every write to assessmentData MUST go through updateAssessmentData below
  // instead of calling setAssessmentData directly. This guarantees
  // assessmentDataRef.current is updated SYNCHRONOUSLY with state, so any
  // out-of-band event handler that reads the ref directly (popstate,
  // beforeunload, the proctoring auto-submit callback, etc.) always sees the
  // latest data — never a stale/empty snapshot from before a React effect
  // had a chance to run.
  const assessmentDataRef = useRef(assessmentData);
  const updateAssessmentData = (updater) => {
    // IMPORTANT: compute `next` synchronously in plain JS and write it to the
    // ref BEFORE touching React state at all. Do NOT rely on the functional
    // form of setState (setAssessmentData(prev => ...)) to do this — under
    // React 18 automatic batching, updates queued from native DOM event
    // listeners (e.g. window 'popstate', which is not a React synthetic
    // event) are NOT guaranteed to run their updater callback synchronously.
    // That means code immediately after setAssessmentData(fn) — like
    // safePostUserResult() in handlePopState — could still see a stale ref,
    // because the updater hadn't been invoked yet. Deriving `next` here in
    // plain JS and assigning the ref immediately removes that race entirely;
    // setAssessmentData is only used afterward to trigger the re-render.
    const prev = assessmentDataRef.current;
    const next = typeof updater === 'function' ? updater(prev) : updater;
    assessmentDataRef.current = next;
    setAssessmentData(next);
    return next;
  };

  const [currentSubject, setCurrentSubject] = useState(null);
  const [showMobilePalette, setShowMobilePalette] = useState(false);
  const [proctoringActive, setProctoringActive] = useState(false);
  const [tabHeaderOffset, setTabHeaderOffset] = useState(null);
  const { violationCount, showWarning, lastViolationType, autoSubmitted, dismissWarning } = useProctoring({
    assessmentId: parseInt(assessmentId, 10) || details?.id || null, userId: userInfo?.id, attemptCount: fromIndex, active: proctoringActive,
    onAutoSubmit: () => safePostUserResult("autosubmit"),
  });

  const isTabletDevice = () => {
    const ua = navigator.userAgent;
    const isIpad = /iPad/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
    const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);
    const isTabletWidth = window.innerWidth >= 768 && window.innerWidth <= 1366 && navigator.maxTouchPoints > 0;
    return isIpad || isAndroidTablet || isTabletWidth;
  };



  useEffect(() => {
    if (!isTabletDevice()) return;

    const getViewport = () => ({
      w: window.visualViewport?.width || window.innerWidth,
      h: window.visualViewport?.height || window.innerHeight,
    });

    const clampCalcPos = () => {
      const { w, h } = getViewport();
      const bx = Math.min(Math.max(calcPos.current.x, 0), w - 52);
      const by = Math.min(Math.max(calcPos.current.y, 0), h - 52);
      calcPos.current = { x: bx, y: by };
      const el = document.getElementById('calc-drag-icon');
      if (el) { el.style.left = `${bx}px`; el.style.top = `${by}px`; }
    };

    const clampWithRetries = () => {
      clampCalcPos();
      requestAnimationFrame(clampCalcPos);
      setTimeout(clampCalcPos, 150);
      setTimeout(clampCalcPos, 400);
    };

    window.addEventListener('resize', clampWithRetries);
    window.addEventListener('orientationchange', clampWithRetries);
    document.addEventListener('fullscreenchange', clampWithRetries);
    window.visualViewport?.addEventListener('resize', clampWithRetries);

    return () => {
      window.removeEventListener('resize', clampWithRetries);
      window.removeEventListener('orientationchange', clampWithRetries);
      document.removeEventListener('fullscreenchange', clampWithRetries);
      window.visualViewport?.removeEventListener('resize', clampWithRetries);
    };
  }, []);

  useEffect(() => {
    if (!isTabletDevice()) return;

    const EXTRA_TOP_SPACE = 12;

    const recalcOffset = () => {
      const headerEl = document.querySelector('#your-app-header-selector');
      const baseHeight = headerEl ? headerEl.offsetHeight : 56;
      setTabHeaderOffset(baseHeight + EXTRA_TOP_SPACE);
    };

    recalcOffset();
    document.addEventListener('fullscreenchange', recalcOffset);
    window.addEventListener('resize', recalcOffset);
    return () => {
      document.removeEventListener('fullscreenchange', recalcOffset);
      window.removeEventListener('resize', recalcOffset);
    };
  }, []);

  const exitFullscreenSafely = () => {
    intentionalExitRef.current = true;
    if (document.fullscreenElement) {
      document.exitFullscreen().catch((e) => console.log('exit fullscreen error', e));
    }
    setProctoringActive(false);
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      const isNowFullscreen = !!document.fullscreenElement;

      if (!isNowFullscreen && testViewRef.current && !intentionalExitRef.current) {
        try {
          const requestFs = isMobileDevice()
            ? document.documentElement.requestFullscreen({ navigationUI: 'hide' })
            : document.documentElement.requestFullscreen();
          requestFs?.catch((e) => console.log('re-enter fullscreen error', e));
        } catch (e) {
          console.log('re-enter fullscreen error', e);
        }
      }
      intentionalExitRef.current = false;
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  };


  useEffect(() => { testViewRef.current = testView; }, [testView]);
  useEffect(() => { currentIndexRef.current = currentIndex; }, [currentIndex]);
  useEffect(() => { currentSubjectRef.current = currentSubject; }, [currentSubject]);
  useEffect(() => { startTimeRef.current = startTime; }, [startTime]);
  useEffect(() => { questionsRef.current = questions; }, [questions]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch(FromGeneralAssessmentView(false));
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    const handlePopState = () => {
      if (testViewRef.current) {
        const endTime = Date.now();
        const timeSpent = (endTime - startTimeRef.current) / 1000;
        const subject = currentSubjectRef.current;
        const currentQ = questionsRef.current[currentIndexRef.current];
        const questionId = currentQ?.id;

        if (subject) {
          // Read from the ref (always in sync thanks to updateAssessmentData)
          // and write back through updateAssessmentData so the ref stays
          // current for the safePostUserResult call right below.
          updateAssessmentData((prevData) => {
            const prevSection = prevData[subject] || {};
            return {
              ...prevData,
              [subject]: {
                ...prevSection,
                currentIndex: currentIndexRef.current,
                timeSpent: {
                  ...(prevSection.timeSpent || {}),
                  ...(questionId && {
                    [questionId]: ((prevSection.timeSpent || {})[questionId] || 0) + timeSpent,
                  }),
                },
              },
            };
          });
        }

        safePostUserResult("autosubmit");
        return;
      }

      onBack();
    };

    window.addEventListener("popstate", handlePopState);
    window.history.pushState(null, "", window.location.pathname);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    if (testView) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [testView]);

  useEffect(() => {
    if (questions?.length > 0 && currentSubject) {
      markVisited(currentSubject, 0);
    }
  }, [questions, currentSubject]);

  useEffect(() => {
    const activeSection = sections.find(
      (s) => s.sectionName === questionType
    );

    const container = containerRef.current;
    const tab = activeSection && tabRefs.current[activeSection.sectionId];

    if (container && tab) {
      const maxScroll = container.scrollWidth - container.clientWidth;
      let left = tab.offsetLeft - container.clientWidth / 2 + tab.clientWidth / 2;
      left = Math.max(0, Math.min(left, maxScroll));
      container.scrollTo({ left, behavior: "smooth" });
    }
  }, [questionType, sections]);


  const onStartTest = () => {
    dispatch(FromGeneralAssessmentView(true));
    setStartTime(Date.now());
    setTestView(true)
    setTime(details?.time_in_mins * 60)
    setVisitedMap({ [questionType]: { 0: true } });
  }
  const onBack = (data) => {
    dispatch(FromGeneralAssessmentView(false));
    document.body.style.overflow = 'auto';
    document.body.style.paddingRight = '0px';
    CallBackAssessmentView(fromIndex|| 0, 1, true, data);
  }

  const disableScroll = () => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  const enableScroll = () => {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
  const handleChangeType = (sectionName) => {
    const endTime = Date.now();
    const timeSpent = (endTime - startTime) / 1000;
    const currentQ = questions[currentIndex];
    const questionId = currentQ?.id;

    updateAssessmentData((prev) => {
      const prevSection = prev[currentSubject] || {};
      const updated = {
        ...prev,
        [currentSubject]: {
          ...prevSection,
          currentIndex,
          timeSpent: {
            ...(prevSection.timeSpent || {}),
            [questionId]: ((prevSection.timeSpent || {})[questionId] || 0) + timeSpent,
          },
        },
      };

      const newSectionQuestions = updated?.[sectionName]?.questions || [];
      const seenPassages = new Set();
      const orderedQuestions = [];
      newSectionQuestions.forEach((q) => {
        if (!q.passage_id) {
          orderedQuestions.push(q);
        } else if (!seenPassages.has(q.passage_id)) {
          const group = newSectionQuestions.filter((item) => item.passage_id === q.passage_id);
          orderedQuestions.push(...group);
          seenPassages.add(q.passage_id);
        }
      });
      setQuestions(orderedQuestions);
      setCurrentIndex(updated?.[sectionName]?.currentIndex || 0);
      setCurrentSubject(sectionName);
      setQuestionType(sectionName);
      setStartTime(Date.now());
      return updated;
    });
  };

  const handleCloseQuestionList = () => {
    setQuestionListAnchorEl(null);
    setOverlayZIndex('none');
  };

  const getAssessmentDetails = async () => {
    const result = await adminServices.getStartAssessment(assessmentId, details?.assessment_pattern_name);
    setCurrentIndex(0)
    if (result.ok) {
      const dynamicAssessment = {};
      const dynamicMarked = {};
      result?.data?.sections?.forEach((section) => {
        dynamicAssessment[section.sectionName] = {
          responses: {},
          timeSpent: {},
          currentIndex: 0,
          questions: section.questions || []
        };
      });

      result?.data?.sections?.forEach((section) => {
        dynamicMarked[section.sectionName] = {};
      });

      setMarkedForReview(dynamicMarked);
      setCurrentSubject(result.data.sections[0].sectionName);
      setQuestionType(result.data?.sections[0]?.sectionName)
      const newQuestions = result.data?.sections[0]?.questions || [];
      const orderedQuestions = (() => {
        const normal = [];
        const passageGroups = {};
        newQuestions.forEach((q) => {
          if (q.passage_id) {
            if (!passageGroups[q.passage_id]) {
              passageGroups[q.passage_id] = [];
            }
            passageGroups[q.passage_id].push(q);
          } else {
            normal.push(q);
          }
        });
        const passageSequential = Object.values(passageGroups).flat();
        return [...normal, ...passageSequential];
      })();

      setQuestions(orderedQuestions);
      updateAssessmentData(dynamicAssessment);
      setSections(result?.data?.sections)
      setAssessmentDetails(result?.data?.assessmentDetails)
      posthog.capture('assessment_started', {
        assessment_id: assessmentId,
        assessment_name: details?.assessment_pattern_name || result?.data?.assessmentDetails?.name,
        section_count: result?.data?.sections?.length,
      });
    }
  };

  const handleSectionTransition = () => {
    if (!sections || sections.length === 0) return;
    const endTime = Date.now();
    const timeSpent = (endTime - startTime) / 1000;
    const currentQuestion = questions[currentIndex];
    const questionId = currentQuestion?.id;

    updateAssessmentData((prev) => {
      const prevSection = prev[currentSubject] || {};
      return {
        ...prev,
        [currentSubject]: {
          ...prevSection,
          currentIndex: currentIndex,
          timeSpent: {
            ...(prevSection.timeSpent || {}),
            [questionId]:
              ((prevSection.timeSpent || {})[questionId] || 0) + timeSpent,
          },
        },
      };
    });

    const currentSectionIndex = sections.findIndex((section) => section.sectionName === currentSubject);
    if (currentSectionIndex === sections.length - 1) {
      handlePostUserResult("");
      return;
    }

    setShowModuleComplete(true);
    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
      setShowModuleComplete(false);
      const nextSection = sections[currentSectionIndex + 1];
      setCurrentSubject(nextSection.sectionName);
      setQuestionType(nextSection.sectionName);
      const newQuestions = assessmentData?.[nextSection.sectionName]?.questions || nextSection.questions || [];
      const seenPassages = new Set();
      const orderedQuestions = [];

      newQuestions.forEach((q) => {
        if (!q.passage_id) {
          orderedQuestions.push(q);
        } else if (!seenPassages.has(q.passage_id)) {
          const group = newQuestions.filter(
            (item) => item.passage_id === q.passage_id
          );
          orderedQuestions.push(...group);
          seenPassages.add(q.passage_id);
        }
      });

      setQuestions(orderedQuestions);
      setCurrentIndex(
        assessmentData?.[nextSection.sectionName]?.currentIndex || 0
      );
      setStartTime(Date.now());
    }, 2000);
  };

  useEffect(() => {
    getAssessmentDetails('');
  }, []);

  

  const currentQuestion = questions && questions[currentIndex];
const isAssessmentFree = details?.is_payment === false && details?.ispaid === false;

  const handlePostUserResult = async (value) => {
    setIsLoading(true);
    const latestData = assessmentDataRef.current;

    const allResponses = Object.keys(latestData).map((sectionName) => ({
      sectionName,
      responses: formatSubjectResponses(sectionName, latestData)
    }));

    const totalTime = Object.values(latestData).reduce((total, subject) => {
      return total + Object.values(subject.timeSpent).reduce((sum, t) => sum + t, 0);
    }, 0);

    const body = {
      assessment_id: assessmentId,
      assessmentName: details?.title,
      type: details?.type,
      user_id: userInfo?.id,
      user_result: allResponses,
      date_started: getCurrentTime(),
      date_completed: getCurrentTime(),
      difference_date: totalTime,
      attempt_count: fromIndex,
      isComplete: value !== 'autosubmit',
      Name: userInfo?.name,
      autosubmit:value,
      is_free: isAssessmentFree,
      role:userInfo?.role

    };
    const result = await adminServices.postAssessmentResult(body);
    if (result.ok) {
      posthog.capture('assessment_submitted', {
        assessment_id: assessmentId,
        total_time_seconds: totalTime,
        attempt_count: fromIndex,
      });
      exitFullscreenSafely();
      setMarkedForReview({});
      setShowCongratulations(true);
      setShowCongratulationsModal(true);
      enableScroll();
      dispatch(FromGeneralAssessmentView(false));
      setTimeout(() => {
        setTestView(false);
        setShowCongratulations(false);
        // Close the congrats <Dialog> BEFORE the parent unmounts this
        // component. Leaving a MUI Dialog mounted-and-open at unmount
        // corrupts MUI's shared ModalManager scroll-lock refcount, which
        // leaves `body { overflow: hidden }` stuck on the page we land on
        // (the assessment overview) — i.e. it becomes un-scrollable.
        setShowCongratulationsModal(false);
        enableScroll();
        const storageKey = userInfo?.role === 'AUTH_USER' ? 'neet_assess_details' : 'assess_details';
        localStorage.setItem(storageKey, JSON.stringify(location.state?.details));
        // Defer the route/view switch one tick so React flushes the
        // Dialog's open=false (ModalManager cleanly releases the lock)
        // before this whole subtree is torn down.
        setTimeout(() => {
          CallBackAssessmentView(location?.state?.index || 0, 1, true, "exam");
        }, 0);
      }, 2000);
    }
  };

  const formatSubjectResponses = (sectionName, data = assessmentData) => {
    const subjectData = data[sectionName];
    if (!subjectData) return [];

    return subjectData.questions.map((question) => ({
      questionId: question.id,
      selectedAnswer: subjectData.responses[question.id] || null,
      timeTaken: subjectData.timeSpent[question.id] || 0,
      multiplier: question?.cognitive_skill_id,
      questionTag: question?.question_tag || null,
    }));
  };

  const getAccurateElapsed = () => {
    const now = Date.now();
    let elapsed = 0;

    if (backgroundStartRef.current) {
      elapsed += backgroundStartRef.current - lastUpdateRef.current;
      elapsed += now - backgroundStartRef.current;
      backgroundStartRef.current = null;
    } else {
      elapsed = now - lastUpdateRef.current;
    }

    lastUpdateRef.current = now;
    return Math.floor(elapsed / 1000);
  };
  const resultPostedRef = useRef(false);
  const lastUpdateRef = useRef(Date.now());
  const backgroundStartRef = useRef(null);
  const timerRef = useRef(null);

  const updateTimer = () => {
    const elapsedSeconds = getAccurateElapsed();
    setTime(prev => {
      const newTime = prev - elapsedSeconds;
      if (newTime <= 0) {
        if (!isPaused && testView) {
          setIsTimeout(true);
          safePostUserResult("timeout");
        }
        return 0;
      }
      return newTime;
    });
  };
  useEffect(() => {
    const activeSection = sections?.find((s) => s.sectionName === questionType);
    const activeEl = activeSection && tabRefs.current[activeSection.sectionId];
    if (activeEl && containerRef.current) {
      activeEl.scrollIntoView({
        behavior: "auto",
        inline: "start",
        block: "nearest",
      });
    }
  }, [questionType, sections]);

  const safePostUserResult = (value) => {
    if (resultPostedRef.current) return;
    resultPostedRef.current = true;
    handlePostUserResult(value);
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearInterval(timerRef.current);
        backgroundStartRef.current = Date.now();
      } else {
        updateTimer();
        startTimer();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isPaused, testView]);

  const startTimer = () => {
    if (!isPaused && time > 0) {
      timerRef.current = setInterval(updateTimer, 1000);
    }
  };

  useEffect(() => {
    lastUpdateRef.current = Date.now();
    startTimer();

    return () => {
      clearInterval(timerRef.current);
    };
  }, [isPaused, time]);

  const formatTimeTimer = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleNext = () => {
    if (!currentSubject) return;
    const endTime = Date.now();
    const timeSpent = (endTime - startTime) / 1000;
    const currentQuestion = questions[currentIndex];
    const questionId = currentQuestion?.id;
    updateAssessmentData((prev) => {
      const prevSection = prev[currentSubject] || {};
      return {
        ...prev,
        [currentSubject]: {
          ...prevSection,
          timeSpent: {
            ...(prevSection.timeSpent || {}),
            ...(questionId && {
              [questionId]:
                ((prevSection.timeSpent || {})[questionId] || 0) + timeSpent,
            }),
          },
          currentIndex:
            currentIndex < questions.length - 1
              ? currentIndex + 1
              : currentIndex,
        },
      };
    });
    if (currentIndex < questions.length - 1) {
      setCurrentIndex((prev) => prev + 1);
      markVisited(currentSubject, currentIndex + 1);
    } else {
      handlePostUserResult("");
    }
    setStartTime(Date.now());
  };

  const handleBack = () => {
    if (!currentSubject) return;
    const endTime = Date.now();
    const timeSpent = (endTime - startTime) / 1000;
    const currentQuestion = questions[currentIndex];
    const questionId = currentQuestion?.id;
    updateAssessmentData((prev) => {
      const prevSection = prev[currentSubject] || {};
      return {
        ...prev,
        [currentSubject]: {
          ...prevSection,
          timeSpent: {
            ...(prevSection.timeSpent || {}),
            ...(questionId && {
              [questionId]:
                ((prevSection.timeSpent || {})[questionId] || 0) + timeSpent,
            }),
          },
        },
      };
    });
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
      markVisited(currentSubject, currentIndex - 1);
    }
    else {
      const currentSectionIndex = sections.findIndex(
        (s) => s.sectionId === currentSubject
      );
      if (currentSectionIndex > 0) {
        const previousSection = sections[currentSectionIndex - 1];
        handleChangeType(previousSection.sectionId);
      }
    }
    setStartTime(Date.now());
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "Are you sure you want to leave? Your progress will not be saved.";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleOptionSelect = async (option, index) => {
    const currentQuestion = questions[currentIndex];
    const questionId = currentQuestion?.id;
    updateAssessmentData(prev => {
      const subjectKey = currentSubject;
      const existingSubject = prev[subjectKey] || {};
      return {
        ...prev,
        [subjectKey]: {
          ...existingSubject,
          responses: {
            ...(existingSubject.responses || {}),
            [questionId]: option
          }
        }
      };
    });
    setSelectedAnswers(prev => ({ ...prev, [questionId]: option }));
  };
  const markVisited = (sectionName, index) => {
    setVisitedMap(prev => ({
      ...prev,
      [sectionName]: { ...(prev[sectionName] || {}), [index]: true }
    }));
  };

  const handleQuestionSelect = (index) => {
    const endTime = Date.now();
    const timeSpent = (endTime - startTime) / 1000;
    const currentQuestion = questions[currentIndex];
    const questionId = currentQuestion?.id;
    updateAssessmentData(prev => {
      const subjectKey = currentSubject;
      const subjectData = prev?.[subjectKey] || {};
      const previousTimeSpent = subjectData?.timeSpent || {};
      return {
        ...prev,
        [subjectKey]: {
          ...subjectData,
          timeSpent: {
            ...previousTimeSpent,
            [questionId]:
              (previousTimeSpent?.[questionId] || 0) + timeSpent
          }
        }
      };
    });
    setCurrentIndex(index);
    markVisited(currentSubject, index);
    setStartTime(Date.now());
    handleCloseQuestionList();
  };

  const handleSubmit = async () => {
    handleSectionTransition();
  };

  const handleMarkForReview = () => {
    const questionId = questions[currentIndex]?.id;
    if (!questionId) return;
    const key = questionType;
    setMarkedForReview((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [questionId]: true,
      },
    }));
    markVisited(currentSubject, currentIndex);
    if (currentIndex < questions.length - 1) {
      const nextIndex = currentIndex + 1;
      setCurrentIndex(nextIndex);
      markVisited(currentSubject, nextIndex);
    } else {
      setCurrentIndex(0);
      markVisited(currentSubject, 0);
    }
    setStartTime(Date.now());
  };

  const handleClearResponse = () => {
    const currentQ = questions[currentIndex];
    const questionId = currentQ?.id;
    if (!questionId) return;
    updateAssessmentData(prev => {
      const updatedResponses = { ...(prev[currentSubject]?.responses || {}) };
      delete updatedResponses[questionId];
      return {
        ...prev,
        [currentSubject]: {
          ...prev[currentSubject],
          responses: updatedResponses,
        },
      };
    });
    setSelectedAnswers(prev => {
      const newAnswers = { ...prev };
      delete newAnswers[questionId];
      return newAnswers;
    });
    setMarkedForReview(prev => ({
      ...prev,
      [questionType]: {
        ...(prev[questionType] || {}),
        [questionId]: false,
      },
    }));
  };

  useEffect(() => {
    if (currentQuestion) {
      let parsedOptions;
      try {
        const parsed = typeof currentQuestion?.options === 'string'
          ? JSON.parse(currentQuestion.options)
          : currentQuestion.options;
        parsedOptions = parsed?.mcqOptions || [];
      } catch (err) {
        console.error('Error parsing options:', err);
        parsedOptions = [];
      }
      setParsedOptions(parsedOptions);
    }
  }, [currentQuestion]);

  useEffect(() => {
    let breakTimer;
    if (resumeTime && testView === true && questionType === 'English') {
      if (breakTimeLeft > 0) {
        breakTimer = setInterval(() => {
          setBreakTimeLeft(prev => {
            if (prev <= 1) {
              clearInterval(breakTimer);
              setTime(2680);
              handleNextModule();
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      }
      return () => clearInterval(breakTimer);
    }
  }, [resumeTime, testView]);

  const handleNextModule = () => {
    setTime(2680)
    setQuestionType('Physcis');
    getAssessmentDetails('Neet');
    setStartTime(Date.now())
    setSubmodule(1);
    setResumeTime(false);
    setBreakTimeLeft(600);
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleCalcMouseDown = (e) => {
    e.preventDefault();
    calcIsDragging.current = true;
    calcDraggedRef.current = false;
    calcDragStartPos.current = { x: e.clientX, y: e.clientY };
    calcLastPos.current = { x: e.clientX, y: e.clientY };
    calcLastTime.current = Date.now();
    calcVelocity.current = { x: 0, y: 0 };
    cancelAnimationFrame(calcInertiaRef.current);

    const onMouseMove = (me) => {
      if (!calcIsDragging.current) return;
      const now = Date.now();
      const dt = now - calcLastTime.current || 16;
      const dx = me.clientX - calcLastPos.current.x;
      const dy = me.clientY - calcLastPos.current.y;

      calcVelocity.current = { x: dx / dt * 16, y: dy / dt * 16 };
      calcLastPos.current = { x: me.clientX, y: me.clientY };
      calcLastTime.current = now;

      const nx = calcPos.current.x + dx;
      const ny = calcPos.current.y + dy;
      const bx = Math.min(Math.max(nx, 0), window.innerWidth - 52);
      const by = Math.min(Math.max(ny, 0), window.innerHeight - 52);
      calcPos.current = { x: bx, y: by };

      const el = document.getElementById('calc-drag-icon');
      if (el) { el.style.left = `${bx}px`; el.style.top = `${by}px`; }

      const moved = Math.abs(me.clientX - calcDragStartPos.current.x) > 5
        || Math.abs(me.clientY - calcDragStartPos.current.y) > 5;
      if (moved) calcDraggedRef.current = true;
    };

    const onMouseUp = () => {
      calcIsDragging.current = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      applyInertia();
    };
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const applyInertia = () => {
    const friction = 0.88;
    const animate = () => {
      calcVelocity.current.x *= friction;
      calcVelocity.current.y *= friction;
      if (Math.abs(calcVelocity.current.x) < 0.3 && Math.abs(calcVelocity.current.y) < 0.3) return;
      const nx = calcPos.current.x + calcVelocity.current.x;
      const ny = calcPos.current.y + calcVelocity.current.y;
      const bx = Math.min(Math.max(nx, 0), window.innerWidth - 52);
      const by = Math.min(Math.max(ny, 0), window.innerHeight - 52);

      if (nx <= 0 || nx >= window.innerWidth - 52) calcVelocity.current.x *= -0.4;
      if (ny <= 0 || ny >= window.innerHeight - 52) calcVelocity.current.y *= -0.4;
      calcPos.current = { x: bx, y: by };
      const el = document.getElementById('calc-drag-icon');
      if (el) { el.style.left = `${bx}px`; el.style.top = `${by}px`; }
      calcInertiaRef.current = requestAnimationFrame(animate);
    };
    calcInertiaRef.current = requestAnimationFrame(animate);
  };

  return (
    <Page title={'Begin Course'} style={{ marginTop: '8px', padding: '0px', paddingTop: '56px !important', overflow: (testView || showCongratulations) ? 'hidden' : 'auto', height: '100vh' }}>

      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
      <Box className="overLay" onClick={() => { handleClose(); handleCloseQuestionList(); }} style={{
        opacity: '1', transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)', position: 'fixed',
        justifyContent: 'center', right: '0', bottom: '0', top: '0', left: '0',
        display: overlayZIndex,
        backgroundColor: 'rgb(12 12 12 / 35%)', zIndex: '1101', width: '100vw',
        height: '100vh'
      }} />
      {testView === false && !showCongratulations &&
        <div className="min-h-screen bg-gray-100 p-3 sm:p-6 " style={{ minHeight: '100dvh' }}>
          <div className="max-w-6xl mx-auto">
            {/* <div className=" bg-white rounded border border-[#F3F4F6] p-3 sm:p-4 mb-6 sm:mb-8  max-h-[50vh] md:max-h-[60vh] lg:max-h-none overflow-y-auto lg:overflow-visible"> */}
            <div className="bg-white rounded border border-[#F3F4F6] p-3 sm:p-4 mb-6 sm:mb-8 overflow-y-auto"
              style={{
                maxHeight: 'min(60vh, 60dvh)', WebkitOverflowScrolling: 'touch',
                overscrollBehavior: 'contain',
                touchAction: 'pan-y',
              }}
            >
              <h2 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                <span className="w-5 h-5 rounded-full border-2 border-gray-900 flex items-center justify-center text-xs text-gray-900 font-bold flex-shrink-0">i</span>
                General Instructions
              </h2>
              <ol className="list-none pl-0 m-0 flex flex-col" style={{ gap: '12px' }}>
                {[
                  "This exam is conducted in online mode only. Ensure a stable internet connection throughout.",
                  "Do not switch browser tabs or windows during the exam. Tab switching may result in disqualification.",
                  "The exam will auto-submit when the timer reaches zero.",
                  "Use the Question Palette on the right to track your progress across all sections.",
                  "Navigation between questions and sections is subject to the specific rules of this assessment.",
                  "Mark for Review allows you to flag a question — marked questions are still counted if answered.",
                  "A basic arithmetic calculator is available via the button at the bottom right corner of the screen.",
                  "Do not refresh the browser page during the exam. Your progress is saved automatically.",
                  "Physical calculators, mobile phones, and electronic devices are not permitted.",
                  "Read each question carefully. There is no option to retrieve your responses after submission.",
                  "For the best experience, take the exam on a laptop or desktop computer."
                ].map((text, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <span style={{
                      width: '16px', height: '16px', backgroundColor: 'transparent',
                      borderRadius: '2px', border: '1px solid #d1d5db', display: 'flex', alignItems: 'center',
                      justifyContent: 'center', fontSize: '10px', color: '#000000',
                      fontFamily: 'Inter', fontWeight: 400, lineHeight: '16px',
                      flexShrink: 0, textAlign: 'center'
                    }}>{i + 1}</span>
                    <span style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '16px', color: '#374151' }}>{text}</span>
                  </li>
                ))}
              </ol>
            </div>
            <div className="border border-gray-200 rounded-2xl overflow-hidden">
              <div className="bg-white px-4 py-2 flex items-start gap-4">
                <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-1 h-4 w-4 rounded border-gray-400 " />
                <p className="text-gray-800 text-[13px] sm:text-[15px] leading-relaxed">
                  <b>Declaration: </b>I have read and understood all the instructions and agree to the examination rules. I understand that any violation of rules may lead to disqualification.
                </p>
              </div>
              <div className="bg-white px-4 py-4 flex items-center justify-between w-full gap-2">
                <button onClick={() => onBack("back")} className="flex items-center gap-1 sm:gap-2 px-3 sm:px-6 py-2 sm:py-2.5 rounded-lg font-semibold border border-gray-300 text-gray-700 hover:bg-gray-100 transition-all duration-200 text-sm whitespace-nowrap"><ChevronLeftIcon sx={{ fontSize: 20 }} /> Back </button>
                <button onClick={() => {
                  try {
                    if (isMobileDevice()) {
                      document.documentElement.requestFullscreen({ navigationUI: 'hide' });
                    } else {
                      document.documentElement.requestFullscreen();
                    }
                  }
                  catch (e) { console.log('error', e) }
                  setProctoringActive(true); onStartTest();
                }}  disabled={!checked && testView === false}  className={`flex items-center gap-2 px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 ${checked ? "bg-[#2F62D6] hover:bg-[#244fb5] text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}>
                  Start Examination
                  <SendIcon sx={{ fontSize: 20 }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      }

      {!resumeTime && testView === true && (
        <Box sx={{ position: "fixed", top: tabHeaderOffset !== null ? `${tabHeaderOffset}px` : "56px", left: 0, right: 0, bottom: 0, display: "flex", flexDirection: "column", backgroundColor: "#ffffff", overflow: "hidden" }} >
          <Box id="topicHead" sx={{ display: "flex", flexDirection: "column", backgroundColor: "#fff", borderBottom: "1px solid #e0e0e0", flexShrink: 0, width: "100%", px: { xs: 2, md: 3 }, py: { xs: 1, md: 0 }, gap: { xs: 1, md: 0 } }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: { xs: 2, md: 3 }, height: { xs: "52px", md: "68px" }, flexShrink: 0 }}>
              <Button onClick={handleClick} variant="outlined" endIcon={<KeyboardArrowDownIcon />}
                sx={{ textTransform: "none", fontSize: { xs: "12px", md: "13px" }, color: "#333", fontWeight: 500, borderColor: "#d1d5db", borderRadius: "8px", whiteSpace: "nowrap", height: { xs: "32px", md: "36px" }, px: { xs: 1.5, md: 2 }, flexShrink: 0 }}>
                Directions
              </Button>
              <Box style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, backgroundColor: '#2563eb', borderRadius: '8px', paddingLeft: '16px', paddingRight: '16px', height: '36px', marginRight: '24px', marginLeft: 1 }}>
                <AccessTimeIcon sx={{ color: '#fff', fontSize: '16px' }} />
                <Typography sx={{ fontWeight: 700, color: '#fff', fontSize: '13px', fontFamily: 'monospace', whiteSpace: 'nowrap', lineHeight: 1 }}>{formatTimeTimer(time)} </Typography>
              </Box>
            </Box>
            <Box
              ref={containerRef}
              sx={{
                borderTop: "1px solid #e5e7eb",
                width: "100%",
                overflowX: "auto",
                overflowY: "hidden",
                flexShrink: 0,
                "&::-webkit-scrollbar": { height: "4px" },
                "&::-webkit-scrollbar-thumb": { backgroundColor: "#c7d2fe", borderRadius: "4px" },
                "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
                scrollbarWidth: "thin",
                scrollbarColor: "#c7d2fe transparent",
              }}
            >


              <Box sx={{
                // Up to 5 sections: fill the row, evenly distributed (no scroll).
                // More than 5: fixed-width tabs with horizontal scroll instead
                // of shrinking indefinitely and clipping labels unreadably.
                // With only 1-2 sections, the 220px maxWidth cap on each tab
                // leaves empty space on the right if left-aligned — center
                // them instead so a single/pair of tabs doesn't look stranded.
                display: "flex",
                alignItems: "stretch",
                justifyContent: sections.length <= 2 ? "center" : "flex-start",
                minHeight: "56px",
                gap: { xs: "4px", md: "2px" },
                px: 2,
                width: sections.length <= 5 ? "100%" : "max-content",
                minWidth: "100%",
              }}
              >
                {sections &&
                  sections.length > 0 &&
                  sections.map((section) => {
                    const isActive = questionType === section.sectionName;
                    const sectionResponses = assessmentData?.[section.sectionName]?.responses || {};
                    const answeredCount = isActive
                      ? Object.values(assessmentData?.[currentSubject]?.responses || {}).filter(
                        (v) => v !== null && v !== undefined
                      ).length
                      : Object.values(sectionResponses).filter((v) => v !== null && v !== undefined).length;

                    const totalCount =
                      assessmentData?.[section.sectionName]?.questions?.length ||
                      section.questionPerAttempt ||
                      section.questions?.length ||
                      0;

                    return (
                      <Box
                        ref={(el) => {
                          tabRefs.current[section.sectionId] = el;
                        }}
                        key={section.sectionId}
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                          if (!details?.allownavigation) return;
                          const endTime = Date.now();
                          const timeSpent = (endTime - startTime) / 1000;
                          const currentQ = questions[currentIndex];
                          const questionId = currentQ?.id;
                          setQuestionTimes((prev) => ({
                            ...prev,
                            [questionId]: (prev[questionId] || 0) + timeSpent,
                          }));
                          handleChangeType(section.sectionName);
                          setStartTime(Date.now());
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            if (!details?.allownavigation) return;
                            const endTime = Date.now();
                            const timeSpent = (endTime - startTime) / 1000;
                            const currentQ = questions[currentIndex];
                            const questionId = currentQ?.id;
                            setQuestionTimes((prev) => ({
                              ...prev,
                              [questionId]: (prev[questionId] || 0) + timeSpent,
                            }));
                            handleChangeType(section.sectionName);
                            setStartTime(Date.now());
                          }
                        }}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "2px",
                          // <=5 sections: grow to fill the row evenly. Setting
                          // minWidth:0 here is essential — flex items default
                          // to min-width:auto, which stops them shrinking
                          // below their content's natural (unwrapped) size
                          // and is exactly what caused the overlap bug
                          // before. With minWidth:0, each tab can shrink to
                          // its fair 1/N share and the label's line-clamp
                          // then has a real, bounded width to wrap against.
                          // The 220px cap only applies to 1-2 sections (stops
                          // a lone tab stretching absurdly wide on desktop).
                          // With 3-5 sections there's NO cap, so flex-grow
                          // fills the entire row instead of stopping short
                          // and leaving empty space on wide/desktop screens.
                          // >5 sections: fixed width, no grow/shrink, scroll.
                          flex: sections.length <= 5 ? "1 1 0" : "0 0 auto",
                          minWidth: sections.length <= 5 ? 0 : { xs: "108px", sm: "128px", md: "148px" },
                          maxWidth: sections.length <= 5
                            ? (sections.length <= 2 ? "220px" : "none")
                            : { xs: "108px", sm: "128px", md: "148px" },
                          minHeight: "56px",
                          overflow: "hidden",
                          px: { xs: 1, md: 1.5 },
                          py: "6px",
                          cursor: details?.allownavigation ? "pointer" : "not-allowed",
                          borderBottom: isActive ? "3px solid #2563eb" : "3px solid transparent",
                          "&:hover": { backgroundColor: "#f9fafb" },
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 700,
                            letterSpacing: "0.5px",
                            textAlign: "center",
                            fontSize: { xs: "9px", md: "10px" },
                            lineHeight: 1.3,
                            color: isActive ? "#2563eb" : "#374151",
                            width: "100%",
                            maxWidth: "100%",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {section.sectionName}
                        </Typography>
                        <Box
                          sx={{
                            borderRadius: "999px",
                            px: "10px",
                            py: "1px",
                            mt: "2px",
                            minWidth: { xs: "42px", md: "48px" },
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: isActive ? "#2563eb" : "#e5e7eb",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: "10px", md: "11px" },
                              fontWeight: 600,
                              color: isActive ? "#fff" : "#6b7280",
                            }}
                          >
                            {answeredCount}/{totalCount}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
              </Box>
            </Box>

            <Popover id={id} open={open} slotProps={{ paper: { sx: { borderRadius: "12px", border: "1px solid #e5e7eb", p: 1, marginTop: "4px", marginLeft: "-9px", maxWidth: { xs: "calc(100vw - 24px)", md: "none" }, maxHeight: "calc(100vh - 72px)", overflowY: "auto" } } }}
              anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} transformOrigin={{ vertical: "top", horizontal: "left" }} disablePortal>
              <Box sx={{ minWidth: { xs: "260px", sm: "600px" }, width: "100%", display: "flex", flexDirection: "column", gap: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" style={{ width: "18px", height: "18px", flexShrink: 0 }}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                  </svg>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>Directions for Test</Typography>
                </Box>
                {[
                  "This exam is conducted in online mode only. Ensure a stable internet connection throughout.",
                  "Do not switch browser tabs or windows during the exam. Tab switching may result in disqualification.",
                  "The exam will auto-submit when the timer reaches zero.",
                  "Use the Question Palette on the right to track your progress across all sections.",
                  "Navigation between questions and sections is subject to the specific rules of this assessment.",
                  "Mark for Review allows you to flag a question — marked questions are still counted if answered.",
                  "A basic arithmetic calculator is available via the button at the bottom right corner of the screen.",
                  "Do not refresh the browser page during the exam. Your progress is saved automatically.",
                  "Physical calculators, mobile phones, and electronic devices are not permitted.",
                  "Read each question carefully. There is no option to retrieve your responses after submission.",
                  "For the best experience, take the exam on a laptop or desktop computer."
                ].map((item, index) => (
                  <Box key={index} sx={{ display: "flex", alignItems: "flex-start", gap: 2, width: "100%" }}>
                    <Box sx={{ minWidth: "24px", height: "24px", borderRadius: "4px", border: "1px solid #e5e7eb", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, mt: "1px" }}>
                      <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "#6b7280" }}>{index + 1}</Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#374151",
                        lineHeight: "1.5",
                        textAlign: "left",
                        flex: 1,
                        minWidth: 0,
                      }}
                    >
                      {item}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Popover>
          </Box>

          <Box sx={{ flex: 1, minHeight: 0, display: "flex", overflow: "hidden" }}>
            <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", backgroundColor: "#ffffff", overflow: "hidden" }}>
              {isLoading ? (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                  <LottieLoading loading={isLoading} />
                </Box>
              ) : (
                currentQuestion && (
                  <>
                    <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: { xs: 2, sm: 3, md: 4 }, py: 2 }}>
                      <QuestionRenderer
                        question={currentQuestion}
                        selectedAnswer={assessmentData?.[currentSubject]?.responses?.[currentQuestion?.id]}
                        currentIndex={currentIndex}
                        onSelect={(value) => handleOptionSelect(value)}
                        onClear={handleClearResponse}
                      />
                    </Box>

                    <Box sx={{ backgroundColor: "#ffffff", height: "60px", display: { xs: "none", md: "flex" }, alignItems: "center", justifyContent: "space-between", px: 3, borderTop: "1px solid #e5e7eb", flexShrink: 0 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Button variant="outlined" startIcon={<FlagOutlinedIcon sx={{ fontSize: 16 }} />} onClick={handleMarkForReview} disabled={isPaused} sx={{ textTransform: "none", fontSize: 13, fontWeight: 500, borderRadius: "8px", backgroundColor: "#F5F3FF", borderColor: "#F5F3FF", color: "#6D28D9", px: 2, py: 0.8, "&:hover": { backgroundColor: "#9333ea", color: "#fff", borderColor: "#9333ea" } }}>
                          Mark for Review & Next
                        </Button>
                        <Button variant="text"
                          startIcon={
                            <svg width="20" height="20" viewBox="0 0 14 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M12.4002 22H4.5999C4.44167 22.0004 4.28493 21.966 4.13871 21.8989C3.99248 21.8317 3.85965 21.7331 3.74786 21.6087L1.35136 18.9427C1.12638 18.6926 1 18.3536 1 18C1 17.6465 1.12638 17.3074 1.35136 17.0574L7.35162 10.3907C7.46306 10.2668 7.59537 10.1686 7.741 10.1015C7.88663 10.0345 8.04272 10 8.20035 10C8.35799 10 8.51408 10.0345 8.6597 10.1015C8.80533 10.1686 8.93765 10.2668 9.04909 10.3907L12.6486 14.3907C12.8736 14.6407 13 14.9798 13 15.3334C13 15.6869 12.8736 16.026 12.6486 16.276L7.50042 22M2.84902 15.3934L8.14605 21.2787" />
                            </svg>
                          }
                          onClick={handleClearResponse}
                          disabled={isPaused}
                          sx={{ textTransform: "none", fontSize: 13, fontWeight: 500, color: "#000", px: 1.5, py: 0.8, borderRadius: "8px", "&:hover": { backgroundColor: "#f3f4f6", color: "#000" } }}
                        >
                          Clear Response
                        </Button>
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon sx={{ fontSize: 16 }} />} onClick={handleBack} disabled={currentIndex === 0 || isPaused}
                          sx={{ textTransform: "none", fontSize: 13, fontWeight: 500, borderRadius: "8px", borderColor: "#e5e7eb", color: "#374151", px: 2, py: 0.8, "&:hover": { borderColor: "#d1d5db", backgroundColor: "#f9fafb" }, "&:disabled": { borderColor: "#f3f4f6", color: "#9ca3af" } }}>
                          Previous
                        </Button>

                        {currentIndex === questions?.length - 1 ? (
                          <Button variant="contained" endIcon={<ChevronRightIcon sx={{ fontSize: 16 }} />} onClick={handleSubmit} disabled={isPaused}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, borderRadius: "8px", backgroundColor: "#6D28D9", color: "#ffffff", px: 2.5, py: 0.8, boxShadow: "none", "&:hover": { backgroundColor: "#6D28D9", boxShadow: "none" } }}>
                            Submit
                          </Button>
                        ) : (
                          <Button variant="contained" endIcon={<ChevronRightIcon sx={{ fontSize: 16 }} />} onClick={handleNext} disabled={isPaused}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, borderRadius: "8px", backgroundColor: "#2563eb", color: "#ffffff", px: 2.5, py: 0.8, boxShadow: "none", "&:hover": { backgroundColor: "#1d4ed8", boxShadow: "none" } }}>
                            Save & Next
                          </Button>
                        )}
                      </Box>
                    </Box>

                    <Box sx={{ display: { xs: "flex", md: "none" }, flexDirection: "column", bgcolor: "#fff", borderTop: "1px solid #e5e7eb", px: 2, py: 1.5, gap: 1, position: "sticky", bottom: 0, zIndex: 1000 }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Button variant="outlined" size="small" startIcon={<FlagOutlinedIcon fontSize="small" />} onClick={handleMarkForReview} sx={{ textTransform: "none", borderColor: "#d1d5db", color: "#4b5563", borderRadius: "8px", px: 1.5, minWidth: 80 }} >
                            Mark
                          </Button>

                          <Button variant="outlined" size="small" onClick={handleClearResponse}
                            startIcon={ <svg width="14" height="14" viewBox="0 0 14 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M12.4002 22H4.5999C4.44167 22.0004 4.28493 21.966 4.13871 21.8989C3.99248 21.8317 3.85965 21.7331 3.74786 21.6087L1.35136 18.9427C1.12638 18.6926 1 18.3536 1 18C1 17.6465 1.12638 17.3074 1.35136 17.0574L7.35162 10.3907C7.46306 10.2668 7.59537 10.1686 7.741 10.1015C7.88663 10.0345 8.04272 10 8.20035 10C8.35799 10 8.51408 10.0345 8.6597 10.1015C8.80533 10.1686 8.93765 10.2668 9.04909 10.3907L12.6486 14.3907C12.8736 14.6407 13 14.9798 13 15.3334C13 15.6869 12.8736 16.026 12.6486 16.276L7.50042 22M2.84902 15.3934L8.14605 21.2787" />
                            </svg>}
                            //   <svg
                            //     width="14"
                            //     height="14"
                            //     viewBox="0 0 24 24"
                            //     fill="none"
                            //     stroke="currentColor"
                            //     strokeWidth="2"
                            //   >
                            //     <path d="M3 6h18M8 6V4h8v2m-9 0l1 14h6l1-14" />
                            //   </svg>
                            // }
                            sx={{ textTransform: "none", borderColor: "#d1d5db", color: "#4b5563", borderRadius: "8px", px: 1.5, minWidth: 80 }}>
                            Clear
                          </Button>
                        </Box>

                        <Button variant="outlined" size="small" startIcon={<GridViewIcon fontSize="small" />} onClick={() => setShowMobilePalette(true)} sx={{ textTransform: "none", borderColor: "#d1d5db", color: "#4b5563", borderRadius: "8px", px: 1.5, }}>
                          Palette ({currentIndex + 1}/{questions?.length})
                        </Button>
                      </Box>

                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Button startIcon={<ChevronLeftIcon />} onClick={handleBack} disabled={currentIndex === 0} sx={{ textTransform: "none", fontWeight: 600, color: "#2563eb" }} >
                          Previous
                        </Button>

                        {currentIndex === questions?.length - 1 ? (
                          <Button
                            variant="contained"
                            endIcon={<ChevronRightIcon />}
                            onClick={handleSubmit}
                            sx={{
                              textTransform: "none",
                              bgcolor: "#2563eb",
                              borderRadius: "8px",
                              px: 2.5,
                              "&:hover": {
                                bgcolor: "#1d4ed8",
                              },
                            }}
                          >
                            Submit
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            endIcon={<ChevronRightIcon />}
                            onClick={handleNext}
                            sx={{
                              textTransform: "none",
                              bgcolor: "#2563eb",
                              borderRadius: "8px",
                              px: 2.5,
                              "&:hover": {
                                bgcolor: "#1d4ed8",
                              },
                            }}
                          >
                            Save & Next
                          </Button>
                        )}
                      </Box>
                    </Box>
                  </>
                )
              )}
            </Box>

            <Box sx={{ backgroundColor: "#ffffff", borderLeft: "1px solid #e0e0e0", overflow: "hidden", display: { xs: "none", md: "flex" }, flexDirection: "column", width: "280px", flexShrink: 0 }}>
              <Box sx={{ flex: 1, overflowY: "auto", p: 2, minHeight: 0 }}>
                <QuestionPalette
                  questions={questions}
                  currentIndex={currentIndex}
                  selectedAnswers={assessmentData?.[currentSubject]?.responses || {}}
                  markedForReview={markedForReview}
                  questionType={questionType}
                  handleQuestionSelect={handleQuestionSelect}
                  visitedMap={visitedMap[questionType] || {}}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <Snackbar open={isopenSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />

      <Dialog
        open={showMobilePalette}
        onClose={() => setShowMobilePalette(false)}
        fullWidth
        maxWidth="xs"
        sx={{ display: { xs: 'block', md: 'none' } }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '15px', fontWeight: 700 }}>
          Question Palette
          <IconButton size="small" onClick={() => setShowMobilePalette(false)}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ maxHeight: '70vh', p: 2 }}>
          <QuestionPalette
            questions={questions}
            currentIndex={currentIndex}
            selectedAnswers={assessmentData?.[currentSubject]?.responses || {}}
            markedForReview={markedForReview}
            questionType={questionType}
            handleQuestionSelect={(index) => {
              handleQuestionSelect(index);
              setShowMobilePalette(false);
            }}
            visitedMap={visitedMap[questionType] || {}}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="confirmDialog"
        fullWidth
        maxWidth="sm"
        sx={{ overflow: { xs: 'auto', sm: 'auto' } }}
      >
        <DialogTitle id="alert-dialog-title" style={{ paddingBottom: '0px !important' }} sx={{ pb: 0, fontSize: { xs: '15px', sm: '20px' } }} textAlign={'center'}>
          Do you really want to submit   {questionType} ?

        </DialogTitle>
        <DialogContent sx={{
          borderTop: '1px solid rgb(163, 163, 163)', padding: { xs: '10px !important', sm: '10px 0px !important' }, borderBottom: '1px solid rgb(163, 163, 163)', overflow: { sx: 'auto', sm: 'auto', md: 'auto', lg: 'auto', xl: 'hidden' },
          overflowX: { lg: "hidden", xl: 'hidden' }, scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": { display: "none", },
        }}>

          <Box id="QuestionModulePop"
            sx={{
              margin: 'auto',

              backgroundColor: 'white',
              padding: { xs: '0px !important', sm: '10px !important', md: '20px !important' },
              paddingTop: '15px !important',
              overflow: 'hidden'

            }}
          >


            <Box sx={{ display: "flex", flexWrap: 'wrap', justifyContent: "space-between", marginBottom: 2, borderBottom: '2px solid #b1b1b1', alignItems: 'baseline', paddingBottom: '12px !important', rowGap: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                <Box sx={{ width: 20, height: 20, backgroundColor: "#B3B3B3", borderRadius: "4px", marginRight: 1 }} />
                <Typography variant="body2">{"Not Answered"}</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ width: 20, height: 20, backgroundColor: "#4caf50", borderRadius: "4px", marginRight: 1 }} />
                <Typography variant="body2">{"Answered"}</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ width: 20, height: 20, backgroundColor: "#2196F3", borderRadius: "4px", marginRight: 1 }} />
                <Typography variant="body2">{"Current"}</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    backgroundColor: '#f1f1f1', width: "20px", height: "20px",
                    fontWeight: "bold", display: "flex", justifyContent: "center",
                    alignItems: "center", cursor: "pointer", borderRadius: '4px',
                    color: '#FFFFFF', position: "relative", marginRight: 1
                  }}>
                  <BookmarkIcon
                    sx={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      fontSize: "16px",
                      color: "#FE780F",
                      transform: "translate(30%, -25%)",
                    }}
                  />
                </Box>
                <Typography variant="body2">{"Marked for Review"}</Typography>
              </Box>
            </Box>
            <Grid container spacing={2} sx={{ maxHeight: '353px', overflowY: 'auto' }}>
              {questions && questions.length > 0 && questions.map((q, index) => {
                const isSelected = currentIndex === index;
                const isAnswered = Object.prototype.hasOwnProperty.call(selectedAnswers, q.id);
                const isMarkedForReview = markedForReview?.[questionType?.toLowerCase()]?.[q.id];

                let backgroundColor = "#B3B3B3";
                if (isAnswered) backgroundColor = "#4caf50";
                if (isSelected) backgroundColor = "#2196F3";

                return (
                  <Grid item xs={3} sm={2} key={index} sx={{ overflow: "visible" }}>
                    <Box
                      onClick={() => handleQuestionSelect(index)}
                      sx={{
                        backgroundColor,
                        width: { xs: "32px", sm: "40px" },
                        height: { xs: "32px", sm: "40px" },
                        fontSize: { xs: "12px", sm: "14px" },
                        fontWeight: "bold",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        borderRadius: '4px',
                        color: '#FFFFFF',
                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                        position: "relative",
                        "&:hover": { backgroundColor: "#1976d2", color: "white" }
                      }}
                    >
                      {isMarkedForReview && (
                        <BookmarkIcon
                          sx={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            fontSize: "26px",
                            color: "#FE780F",
                            transform: "translate(30%, -25%)",
                          }}
                        />
                      )}
                      {index + 1}
                    </Box>
                  </Grid>
                );
              })}
            </Grid>


            <p style={{
              height: '5px',
              display: 'flex',
              justifyContent: 'center',
              margin: '0'
            }}>
              <span className="reviewBtn"
                style={{
                  position: 'relative',

                }}><br /></span>
            </p>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box style={{ display: 'flex', justifyContent: 'space-between', flex: 2, padding: '0 20px', marginBottom: '10px' }}>
            <Button
              variant="outlined"
              onClick={() => setOpenConfirmDialog(false)}

              style={
                {
                  border: '1px solid #02457a', borderRadius: '4px', color: '#02457a',
                  '&:hover': {
                    backgroundColor: '#80abd6ff !important',
                  },
                }
              }
            >
              {"Back"}
            </Button>
            <Button variant="outlined"
              onClick={() => {
                const isLastSection = sections.findIndex(s => s.sectionName === currentSubject) === sections.length - 1;
                if (isLastSection) {
                  handlePostUserResult("");
                } else {
                  handleSectionTransition();
                }
              }}
              style={{ border: '1px solid #02457a', borderRadius: '4px', color: '#02457a', '&:hover': { backgroundColor: '#80abd6ff !important', }, }}>
              {"Submit"}
            </Button>
          </Box>


        </DialogActions>
      </Dialog>

      <Dialog open={showCongratulationsModal} disableEscapeKeyDown slotProps={{ backdrop: { style: { backgroundColor: '#fff' } } }} sx={{ '& .MuiDialog-paper': { borderRadius: '12px', padding: { xs: '12px', sm: '20px' }, textAlign: 'center', minWidth: { xs: '280px', sm: '400px' } } }}>
        <DialogContent sx={{ padding: '20px' }}>
          <div style={{ marginTop: '0px', paddingBottom: '10px' }}>
            <div className="flex justify-center mb-4">
              <div className="relative inline-block">
                <img style={{ justifySelf: 'center', width: '60px', marginBottom: '10px' }} src={TestComplete} alt="Timeout Icon" className="w-16 h-16" />
              </div>
            </div>

            <h2 className="text-xl font-bold text-blue-600" id="canvas" style={{ textAlign: 'center', marginTop: '5px', fontWeight: '700', color: "#6c98fd !important" }}>Congratulations!</h2>
            <p className="text-gray-600 mt-2" style={{
              textAlign: 'center', marginTop: '10px'
            }}>
              You have successfully completed the Test.
            </p>

          </div>

          <LottieLoading />
        </DialogContent>
      </Dialog>


      {!isMobileDevice && details?.allowcalculator === true && testView && (
        <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', pointerEvents: 'none', zIndex: 1300, overflow: 'hidden' }}>
          <Box
            id="calc-drag-icon"
            sx={{
              position: 'absolute',
              width: '52px',
              height: '52px',
              pointerEvents: 'auto',
              userSelect: 'none',
              left: `${calcPos.current.x}px`,
              top: `${calcPos.current.y}px`,
            }}
          >
            {calculatorOpen && (() => {
              const BTN = 52;
              const CALC_W = Math.min(320, window.innerWidth - 24);
              const CALC_H = 420;
              const openRight = calcPos.current.x + BTN + CALC_W + 8 <= window.innerWidth;
              const openDown = calcPos.current.y + CALC_H + 8 <= window.innerHeight;
              return (
                <Box
                  className="calculator-content"
                  sx={{
                    position: 'absolute',
                    ...(openRight ? { left: BTN + 8 } : { right: BTN + 8 }),
                    ...(openDown ? { top: 0 } : { bottom: 0 }),
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
                    backgroundColor: '#fff',
                    cursor: 'default',
                    width: `${CALC_W}px`,
                    zIndex: 2,
                  }}
                >
                  <Box onClick={() => setCalculatorOpen(false)} sx={{ position: 'absolute', top: '8px', right: '8px', width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10, '&:hover': { backgroundColor: '#e5e7eb' } }}>
                    <CloseIcon sx={{ fontSize: 14, color: '#dc2626' }} />
                  </Box>
                  <Box sx={{ pt: '8px', backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Calculator />
                  </Box>
                </Box>
              );
            })()}

            <Tooltip title={calculatorOpen ? 'Close Calculator' : 'Calculator'}>
              <Box onMouseDown={handleCalcMouseDown}
                onClick={() => { if (calcDraggedRef.current) { calcDraggedRef.current = false; return; } setCalculatorOpen(prev => !prev); }}
                sx={{
                  width: '52px', height: '52px', borderRadius: '50%',
                  backgroundColor: '#1976d2',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'grab',
                  '&:active': { cursor: 'grabbing' },
                  boxShadow: '0px 4px 12px rgba(0,0,0,0.3)',
                  transition: 'background-color 0.2s',
                  '&:hover': { backgroundColor: '#1565c0' },
                  WebkitUserDrag: 'none',
                }}
              >
                <img alt='calculator' src={IconCalculator} draggable={false} style={{ width: '28px', height: '28px', filter: 'brightness(0) invert(1)', pointerEvents: 'none' }} />
              </Box>
            </Tooltip>
          </Box>
        </Box>
      )}
      <ProctoringWarningModal open={showWarning} violationCount={violationCount} violationType={lastViolationType} onClose={dismissWarning} />

    </Page>
  );
};

export default AssessmentSimulation;
